import { useNavigation } from 'adapter/in/common/hooks/useNavigation';
import { analysisPath, reportsTemplatePath } from 'adapter/in/common/routes';
import WidgetActionsMenu from 'adapter/in/dashboards/pages/Widget/ActionsMenu';
import useOnDeleteReportAnalysisModal from 'adapter/in/reports/components/DeleteReportAnalysisModal/useDeleteReportAnalysisModal';
import { ReportTemplateFormFields, useTypedFormikContext } from 'adapter/in/reports/components/GenericForm/GenericFormikAdapter';
import React from 'react';

interface ReportAnalysisActionsMenuProps {
    analysisId: string;
    dashboardId: string;
    showMenu: boolean;
}

const ReportAnalysisActionsMenuContainer: React.FC<ReportAnalysisActionsMenuProps> = (props) => {
    const { analysisId, dashboardId, showMenu } = props;
    const { navigationPush } = useNavigation();
    const { values: formValues } = useTypedFormikContext<ReportTemplateFormFields>();
    const { onDeleteModal, handleOnDelete } = useOnDeleteReportAnalysisModal(dashboardId, analysisId);

    const contextParam = formValues.period ? `?context=${formValues.period}` : '';

    return (
        <>
            <WidgetActionsMenu
                show={showMenu}
                showOptions={false}
                onDelete={() => {
                    handleOnDelete();
                }}
                onEdit={() => {
                    navigationPush(`${analysisPath}/${analysisId}${contextParam}`, `${reportsTemplatePath}/${dashboardId}`);
                }}
                isEditDisabled={() => false}
            />
            {onDeleteModal}
        </>
    );
};

export default ReportAnalysisActionsMenuContainer;
